const serviceAuthorized = (authorizedServices = [], services = []) => {
  const authorizedArray = services.filter(service => {
    const authId = service.authId ? service.authId.toLowerCase() : null

    return (
      authorizedServices.includes(service.name.toLowerCase()) ||
      authorizedServices.includes(authId)
    )
  })

  return authorizedArray
}

export default serviceAuthorized



// WEBPACK FOOTER //
// ./src/utility/serviceAuthorized.js